import axios from "axios";

const axiosKeyInstance = axios.create({
  baseURL: process.env.REACT_APP_AUTH_BASE_URL,
  headers: {
    'Content-Type' : "application/x-www-form-urlencoded",
    }
});

// axiosKeyInstance.interceptors.response.use(
//   (response) => response,
//   (error) => console.log(error)
// );
axiosKeyInstance.interceptors.response.use(
  (response) => response,
  // (error) => error.response
  // (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong!')
  (error) => Promise.reject(error?.response?.data || "Something went wrong!")
);

export default axiosKeyInstance;
